import window from 'window';
import $ from 'jquery';
import 'jquery-ui/ui/version';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-no';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'c3';
import 'd3';
import 'chart.js/dist/Chart.bundle';
import 'chartjs-gauge/dist/chartjs-gauge';
import 'chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels';
import { Popover } from 'bootstrap';
import 'AdminPages/init-bootstrap';
import 'bootstrap-select';
import 'daterangepicker';
import 'moment';

import 'Common/Validation';
import 'devbridge-autocomplete';
import 'chosen-js';
import 'chosen-js/chosen.css';

import './';
import 'AdminPages/Search';
import 'AdminPages/Charts/ChartBlocks';
import 'AdminPages/Organizations/OrganizationAdminPage';
import 'AdminPages/SendTickets/Scripts/SendTicketsList';
import '../frontend/sass/admin-style';
import 'Common/Formatting';

const moment = require('moment');
window.jQuery = $;
$.fn.selectpicker.Constructor.BootstrapVersion = 5;

/* eslint-disable no-unused-vars */
const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl);
});
/* eslint-enable quote-props */

$('.daterange').daterangepicker({
    autoUpdateInput: false,
    timePicker: true,
    timePicker24Hour: true,
    ranges: {
        'I dag': [moment(), moment()],
        'I går': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Siste 7 dager': [moment().subtract(6, 'days'), moment()],
        'Siste 30 dager': [moment().subtract(29, 'days'), moment()],
        'Denne måneden': [moment().startOf('month'), moment().endOf('month')],
        'Siste måneden': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    },
    locale: {
        format: 'DD/MM HH:mm',
        cancelLabel: 'Clear'
    }
});

$('.daterange').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format('DD/MM/YYYY HH:mm') + ' - ' + picker.endDate.format('DD/MM/YYYY HH:mm'));
    const form = $(this).closest('form');
    if (form) {
        form.submit();
    }
});

$('.daterange-single').daterangepicker({
    timeZone: null,
    singleDatePicker: true,
    showDropdowns: true,
    autoApply: true,
    minYear: 1901,
    locale: {
        format: 'yyyy-MM-DD',
        cancelLabel: 'Clear'
    }
});

/* eslint-enable quote-props */
